import { CreateDirectoryDto, FindDirectoriesAndFilesQueryDto, FindDirectoriesAndFilesResponse, findDirectoryQueryDto, findDirectoryResponse } from '@/@types/Directory';
import { TheoryApiAxiosBase } from '@/repository/base/axiosBase';
import { Util } from '@/repository/repositories/utils';

export class DirectoriesRepository {
  private readonly requestBasePath = 'v1/directories';
  private readonly axios = new TheoryApiAxiosBase();
  private readonly util = new Util();
  /** ディレクトリ・ファイル一覧取得 */
  async findDirectoriesAndFiles(query: FindDirectoriesAndFilesQueryDto) {
    if (query['parent-directory-id'] !== undefined && query['parent-directory-id'] === null) {
      delete query['parent-directory-id'];
    }
    return (await this.axios.get<FindDirectoriesAndFilesResponse>(
      this.requestBasePath,
      { params: query },
    )).data;
  }

  /** ディレクトリ詳細取得 */
  async findDirectory(directoryId: number, query: findDirectoryQueryDto) {
    return (await this.axios.get<findDirectoryResponse>(
      `${this.requestBasePath}/${directoryId}`,
      { params: query },
    )).data;
  }

  /** ディレクトリ追加 */
  async createDirectory(params: CreateDirectoryDto) {
    await this.axios.post(this.requestBasePath, params);
  }

  /**ディレクトリ削除 */
  async deleteDirectory(directoryId: number, projectId: number) {
    const endPoint = `${this.requestBasePath}/${directoryId}`;
    const query = { 'project-id': projectId };
    await this.axios.delete(endPoint, { params: query });
  }

  private endPointCreator(...paths: (string | number)[]) {
    return this.util.endPointCreator(this.requestBasePath, ...paths);
  }
}
